import React from 'react';
import I18n from 'i18n-js';

import CSPReviewButton from './csp_review_button';
import { CoreItem2CspReviews, Item2ProductModuleData } from '../schemas/rql';

interface IProps {
  onSubmit: (data: any) => void;
  csp: CoreItem2CspReviews.Csp;
  image: Item2ProductModuleData.Image;
}

export function CspReviewsPrompt({ onSubmit, csp, image }: IProps) {
  if (!csp) return null;
  const { reviews, title } = csp;
  const { myReview } = csp.reviews;
  const totalReviews = reviews.total;

  if (totalReviews === 0) return null;
  return (
    <div className="csp-reviews__prompt" data-header-write-prompt>
      <small>
        {I18n.t('discovery.cspReviewModule.writePrompt')}
      </small>
      <div className="mt-half mobile-mt-1">
        <CSPReviewButton
          onSubmit={onSubmit}
          myReview={myReview}
          productTitle={title}
          productImage={image.source}
        />
      </div>
    </div>
  );
}
